import { useState } from "react";
import { useAuth } from "@/contexts/auth-context";
import { Button } from "@/components/ui/button";
import { TxtInput } from "@/components/vehicle-form-fields";

// Mostrado só quando a sessão do GPS Drive Backend expira (ver
// auth-context.tsx#gpsDriveStatus) — nunca quando é o Traccar que caiu
// (isso é outro fluxo, o AuthGate normal). Reautentica só o GPS Drive
// Backend: não mexe na sessão do Traccar, então o mapa/rastreamento
// continuam funcionando por trás deste aviso.
export function GpsDriveSessionBanner() {
  const { gpsDriveStatus, reauthenticateGpsDrive } = useAuth();
  const [email, setEmail] = useState("");
  const [password, setPassword] = useState("");
  const [submitting, setSubmitting] = useState(false);
  const [error, setError] = useState<string | null>(null);

  if (gpsDriveStatus !== "expired") return null;

  const handleSubmit = async (e: React.FormEvent) => {
    e.preventDefault();
    setSubmitting(true);
    setError(null);
    try {
      await reauthenticateGpsDrive(email, password);
      setPassword("");
    } catch {
      setError("Login ou senha inválidos para o GPS Drive Backend.");
    } finally {
      setSubmitting(false);
    }
  };

  return (
    <div className="flex flex-col gap-2 border-b border-amber-500/30 bg-amber-500/10 px-6 py-3 text-sm sm:flex-row sm:items-center sm:justify-between">
      <div>
        <span className="font-semibold text-amber-700 dark:text-amber-400">
          Sessão de gestão expirada.
        </span>{" "}
        <span className="text-amber-700/90 dark:text-amber-400/90">
          Fotos e cadastro dos veículos não aparecem nem podem ser salvos até você reautenticar
          — o rastreamento continua funcionando normalmente.
        </span>
      </div>
      <form className="flex flex-wrap items-center gap-2" onSubmit={handleSubmit}>
        <TxtInput
          type="text"
          autoCapitalize="none"
          autoCorrect="off"
          placeholder="E-mail, CPF ou usuário"
          value={email}
          onChange={(e) => setEmail(e.target.value)}
          className="h-8 w-40 text-xs"
          required
        />
        <TxtInput
          type="password"
          placeholder="Senha"
          value={password}
          onChange={(e) => setPassword(e.target.value)}
          className="h-8 w-32 text-xs"
          required
        />
        <Button type="submit" size="sm" variant="outline" disabled={submitting}>
          {submitting ? "Entrando…" : "Reautenticar"}
        </Button>
        {error && <span className="text-xs text-red-600">{error}</span>}
      </form>
    </div>
  );
}
